import React, { createContext, useContext } from 'react'
import { useAuth, User } from '../hooks/useAuth'
import { UserProfile } from '../types/auth'
import LoadingSpinner from '../components/ui/LoadingSpinner'

type AuthContextType = {
  user: User | null
  userProfile: UserProfile | null
  loading: boolean
  signOut: () => Promise<void>
  login: (email: string, password: string) => Promise<{ success: boolean; error?: string }>
}

const AuthContext = createContext<AuthContextType>({
  user: null,
  userProfile: null,
  loading: true,
  signOut: async () => { },
  login: async () => ({ success: false })
})


export function AuthProvider({ children }: { children: React.ReactNode }) {
  const auth = useAuth()

  if (auth.loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-50 dark:bg-dark-bg">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  return (
    <AuthContext.Provider value={auth}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuthContext() {
  return useContext(AuthContext)
}